import PrivacyTerms from './privacy-terms';

export default PrivacyTerms;